import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Separator } from '../components/ui/separator';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import { services } from '../altiora-mock';

const AltioraServices = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-gradient-to-br from-gray-50 to-teal-50 py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Our Services</h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Comprehensive order-to-cash solutions designed for small-cap US businesses
          </p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-16">
        <div className="max-w-5xl mx-auto space-y-12">
          {services.map((service, index) => (
            <Card key={service.id} className="border-2 hover:border-teal-500 transition-all">
              <CardContent className="p-8">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                  {/* Service Info */}
                  <div className="lg:col-span-2 space-y-4">
                    <div className="flex items-center gap-3">
                      <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center">
                        <span className="text-2xl font-bold text-teal-600">{index + 1}</span>
                      </div>
                      <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
                        {service.title}
                      </h2>
                    </div>
                    
                    <p className="text-lg text-gray-600">{service.description}</p>
                    
                    <Separator />
                    
                    <div>
                      <h3 className="text-lg font-bold text-gray-900 mb-4">Key Features:</h3>
                      <ul className="space-y-3">
                        {service.features.map((feature, idx) => (
                          <li key={idx} className="flex items-start gap-3">
                            <CheckCircle2 className="w-5 h-5 text-teal-600 flex-shrink-0 mt-0.5" />
                            <span className="text-gray-700">{feature}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  
                  {/* CTA Sidebar */}
                  <div className="lg:col-span-1">
                    <Card className="bg-gray-50 border-none">
                      <CardContent className="p-6 space-y-4">
                        <h3 className="font-bold text-gray-900">Interested in this service?</h3>
                        <p className="text-sm text-gray-600">
                          Get a free consultation to discuss how we can help optimize your processes.
                        </p>
                        <Link to="/contact">
                          <Button className="w-full bg-teal-600 hover:bg-teal-700 text-white font-semibold">
                            Get Free Consultation
                            <ArrowRight className="ml-2 w-4 h-4" />
                          </Button>
                        </Link>
                      </CardContent>
                    </Card>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Additional Services Note */}
        <div className="max-w-5xl mx-auto mt-16">
          <Card className="bg-gradient-to-br from-teal-50 to-blue-50 border-2 border-teal-200">
            <CardContent className="p-8 text-center">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                Need a Custom Solution?
              </h2>
              <p className="text-lg text-gray-600 mb-6">
                We also offer shipping back work and customized accounting services tailored to your specific business needs.
              </p>
              <Link to="/contact">
                <Button size="lg" className="bg-teal-600 hover:bg-teal-700 text-white font-semibold px-8">
                  Contact Us for Custom Solutions
                </Button>
              </Link>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default AltioraServices;
